import React from 'react'
import {useNavigate} from 'react-router-dom'
import {Button, Flex, H1, H2, NumberField, NumericStepper} from '@sbab-ui/components'
import styles from './styles.module.scss'

const Questionnaire = ({ state, dispatch, actions }) => {
  const navigate = useNavigate()

  const handleSubmit = () => {
    dispatch({ type: actions.SUBMIT })
    navigate('result')
  }

  return (
    <>
        <H1 className={styles.header}>Hur stor buffert vill du ha?</H1>
        <Flex gap="2rem" direction="column">
            <Flex direction="column" gap="0rem" mb="1rem">
                <p className='secondary'>
                    Ange antal månader som du vill att din buffert ska kunna täcka dina
                    utgifter.
                </p>
                <NumericStepper
                    label='Antal månader'
                    min={1}
                    max={99}
                    value={state.months}
                    onChange={value =>
                        dispatch({type: actions.INPUT_MONTHS, payload: value})
                    }
                />
            </Flex>
            <Flex direction="column" gap="1rem">
                <div>
                    <H2>Fasta utgifter</H2>
                    <p className='secondary'>Hur stora fasta utgifter har du per månad?</p>
                </div>
                <NumberField suffix='kr' label="Boendekostnader"
                             description="(hyra, avgift, ränta eller amortering per månad, el, värme)"
                             value={state.expenses.housing}
                             min={0}
                             onChange={value => dispatch({
                                 type: actions.INPUT_EXPENSE,
                                 payload: {type: 'housing', value},
                             })}
                />
                <NumberField suffix='kr' label="Transportkostnader" description="(bil och andra transportmedel)"
                             value={state.expenses.transport}
                             min={0}
                             onChange={value => dispatch({
                                 type: actions.INPUT_EXPENSE,
                                 payload: {type: 'transport', value},
                             })}
                />
                <NumberField suffix='kr' label="Övrigt"
                             description="(studielån, övriga lån, försäkringar, abonnemangskostnader, gymkort)"
                             value={state.expenses.other}
                             min={0}
                             onChange={value => dispatch({
                                 type: actions.INPUT_EXPENSE,
                                 payload: {type: 'other', value},
                             })}
                />
            </Flex>
            <Flex direction="column" gap="1rem">
                <div>
                    <H2>Om du har barn</H2>
                    <p className='secondary'>
                        Ange dina utgifter för barn som bor hemma eller andra personer som du
                        ansvarar ekonomiskt för.
                    </p>
                </div>
                <NumberField suffix='kr' label="Kostnad per månad"
                             value={state.expenses.children}
                             min={0}
                             onChange={value => dispatch({
                                 type: actions.INPUT_EXPENSE,
                                 payload: {type: 'children', value},
                             })}
                />
            </Flex>
            <Flex direction="column" gap="1rem">
                <div>
                    <H2>Matkostnader</H2>
                    <p className='secondary'>
                        Vad är den minsta kostnaden för mat du tror att du är bekväm att klara
                        dig på under en månad?
                    </p>
                </div>
                <NumberField suffix="kr" label="Matkostnader per månad"
                             value={state.expenses.food}
                             min={0}
                             onChange={value => dispatch({
                                 type: actions.INPUT_EXPENSE,
                                 payload: {type: 'food', value},
                             })}
                />
            </Flex>
            <Flex direction="row" justify={'space-between'} mt="2rem">
                <Button
                    variant='secondary'
                    size='large'
                    onClick={() => dispatch({type: actions.CLEAR})}
                >
                    Återställ formulär
                </Button>
                <Button variant='primary' size='large' onClick={handleSubmit}>
                    Visa resultat
                </Button>
            </Flex>
        </Flex>
    </>
  )
}

export { Questionnaire }
